import { createContext } from 'react';
import Keycloak from 'keycloak-js';
import { keycloakAuthUrl } from 'src/config';

const hostName = window.location.hostname;
const pathName = window.location.pathname;

export const getRealmName = () => {
  if (hostName === 'localhost') {
    if (localStorage.getItem('realm')) {
      return localStorage.getItem('realm');
    }
    return pathName.split('/')[1];
  } else {
    return hostName.split('-')[0];
  }
};

export const keycloak = new Keycloak({
  url: keycloakAuthUrl,
  realm: getRealmName() || '',
  clientId: 'js-client',
});

try {
  //  @ts-ignore
  await keycloak.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
    scope: 'openid',
    redirectUri:
      hostName === 'localhost'
        ? `${window.location.origin}/${getRealmName()}`
        : `${window.location.origin}`,
  });
} catch (error) {
  console.error('Failed to initialize keycloak adapter:', error);
}

const AuthContext = createContext<Keycloak>(keycloak);

export interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return <AuthContext.Provider value={keycloak}>{children}</AuthContext.Provider>;
};

export const getAccessToken = () => {
  return new Promise<string>((resolve, reject) => {
    if (keycloak.authenticated) {
      keycloak
        .updateToken(120)
        .then(() => {
          console.log('Token Refreshed');
          resolve(keycloak.token as string);
        })
        .catch(() => {
          reject('Failed to get access token');
        });
    } else {
      reject('Not logged in');
    }
  });
};

export const logoutUser = () => {
  const realm = localStorage.getItem('realm') || '';
  localStorage.clear();
  if (hostName === 'localhost') {
    keycloak.logout({ redirectUri: `${window.location.origin}/${realm}` });
  } else {
    keycloak.logout({ redirectUri: window.location.origin });
  }
};

export default AuthContext;
